module.exports = __webpack_public_path__ + "static/media/plus_food_julieta.b33efc22.jpg";